import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import PhotoSwipe from "photoswipe";
import tippy from "tippy.js";
import overlay from "../modules/overlay";
import LazyLoad from "vanilla-lazyload";

const templateQuality = {
  init: function () {
    overlay.init();

    templateQuality.video();
    templateQuality.advantages();
    templateQuality.gallery.init();
  },

  video: function () {
    // On click load video and play it
    $(".video-play").on("click", function (e) {
      e.preventDefault();
      $(".video-play__btn").fadeOut();
      var video_dom = $(".video-wrap__video");
      LazyLoad.load(video_dom[0]);
      setTimeout(function () {
        video_dom.addClass("video-wrap__video--active");
        video_dom[0].play();
      }, 250);
    });
  },

  advantages: function () {
    var rows_in_block = $(".advantages-table").data("block");
    var rows = $(".advantages-table__content .advantages-table__row");

    var more_btn = $(".advantages .read-more");
    if (rows.length >= rows_in_block) {
      more_btn.removeClass("read-more--hidden");
    }

    more_btn.on("click", function (e) {
      e.preventDefault();
      var hidden_rows = rows.not(".visible");

      // Load more
      var i = 1;
      hidden_rows.each(function () {
        $(this).slideDown(250).addClass("visible");
        if (i == rows_in_block) return false;
        i++;
      });

      // Hide btn
      if (hidden_rows.length <= rows_in_block) {
        more_btn.hide();
      }
    });

    tippy(".wine-supports__info__circle", {
      placement: "right",
      arrow: true,
      animation: "fade",
    });
  },

  gallery: {
    loading: false,
    main: $(".gallery-slider"),
    thumbs: $(".gallery-thumbs"),

    init: function () {
      if ($(".gallery-block").length) {
        this.main_slider(this.main);
        this.thumbs_slider(this.thumbs);
        this.load_pswd_el();
        this.change_type();
      }
    },
    load_pswd_el: function () {
      var that = this;
      $.ajax({
        url: ajaxurl,
        data: {
          action: "photoswipe",
        },
        type: "POST",
        dataType: "JSON",
        success: function (response) {
          $(".main").append(response);

          templateQuality.overlay();
        },
      });
    },

    main_slider: function (el) {
      el.on("init", function (event, slick) {
        var currentSlide = slick.currentSlide;
        var nextSlide = currentSlide + 1;
        $('.slick-slide[data-slick-index="' + currentSlide + '"]')
          .find(".gallery-slider__slide")
          .addClass("gallery-slider__slide--current");
        $('.slick-slide[data-slick-index="' + nextSlide + '"]')
          .find(".gallery-slider__slide")
          .addClass("gallery-slider__slide--next");
      });

      el.slick({
        asNavFor: ".gallery-thumbs",
        prevArrow:
          '<button class="slick-prev" aria-label="prev"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="#242032"><path d="M6,0V4H16V6H6v4L0,4.94Z"/></svg></button>',
        nextArrow:
          '<button class="slick-next" aria-label="next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="#242032"><path d="M6,0V4H16V6H6v4L0,4.94Z" transform="translate(16 10) rotate(180)"/></svg></button>',
        centerMode: true,
        centerPadding: 0,
        focusOnSelect: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      });

      el.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        // Current
        $('.slick-slide[data-slick-index="' + currentSlide + '"]')
          .find(".gallery-slider__slide")
          .removeClass("gallery-slider__slide--current");

        // Next
        $('.slick-slide[data-slick-index="' + nextSlide + '"]')
          .find(".gallery-slider__slide")
          .addClass("gallery-slider__slide--animating");
        $('.slick-slide[data-slick-index="' + nextSlide + '"]')
          .find(".gallery-slider__slide")
          .removeClass("gallery-slider__slide--next");

        // + 2
        var nextNextSlide = nextSlide + 1;
        $('.slick-slide[data-slick-index="' + nextNextSlide + '"]')
          .find(".gallery-slider__slide")
          .addClass("gallery-slider__slide--next");
      });

      el.on("afterChange", function (event, slick, currentSlide) {
        var nextSlide = currentSlide + 1;
        // Current
        $('.slick-slide[data-slick-index="' + currentSlide + '"]')
          .find(".gallery-slider__slide")
          .removeClass("gallery-slider__slide--animating");
        $('.slick-slide[data-slick-index="' + currentSlide + '"]')
          .find(".gallery-slider__slide")
          .addClass("gallery-slider__slide--current");
      });
    },

    thumbs_slider: function (el) {
      el.slick({
        asNavFor: ".gallery-slider",
        arrows: false,
        centerMode: true,
        lazyLoad: "progressive",
        focusOnSelect: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,

        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      });
    },

    change_type: function () {
      $(".gallery-block__nav__item").on("click", function (e) {
        e.preventDefault();
        if (templateQuality.gallery.loading) {
          return;
        }
        var id = $(this).data("type");
        $(this)
          .addClass("gallery-block__nav__item--active")
          .siblings()
          .removeClass("gallery-block__nav__item--active");
        templateQuality.gallery.load_type(id);
      });
    },

    load_type: function (id) {
      if (templateQuality.gallery.loading) {
        return;
      }
      templateQuality.gallery.loading = true;

      var nonce = $("#nonce").val();
      $.ajax({
        url: ajaxurl,
        type: "POST",
        data: {
          action: "change_gallery",
          type_id: id,
          nonce: nonce,
        },
        beforeSend: function (xhr) {
          $(".gallery-block__type").addClass("loading");
        },
        success: function (response) {
          if (response.success) {
            $(".gallery-block__type").html(response.data.gallery);
            templateQuality.gallery.main_slider($(".gallery-slider"));
            templateQuality.gallery.thumbs_slider($(".gallery-thumbs"));
          }

          setTimeout(function () {
            templateQuality.gallery.loading = false;
            $(".gallery-block__type").removeClass("loading");
          }, 250);
        },
      });
    },
  },

  overlay: function () {
    // Expand image on click
    $("body").on(
      "click",
      ".slick-current .gallery-slider__slide__img",
      function () {
        // Construct images array
        var items = [];
        $(".gallery-slider-images span").each(function () {
          var img = $(this);
          items.push({
            src: img.data("img"),
            w: img.data("width"),
            h: img.data("height"),
          });
        });

        var current = parseInt($(this).data("item"));

        var options = {
          index: current,
          closeOnScroll: false,
          zoomEl: false,
          shareEl: false,
          counterEl: false,
          clickToCloseNonZoomable: false,
          closeElClasses: ["caption", "zoom-wrap", "ui"],
          allowUserZoom: false,
          maxSpreadZoom: 1,
          getDoubleTapZoom: function (isMouseClick, item) {
            return item.initialZoomLevel;
          },
          history: false,
          tapToToggleControls: false,
          barsSize: {
            top: 44,
            bottom: 0,
          },
        };

        var pswpElement = document.querySelectorAll(".pswp")[0];

        var gallery = new PhotoSwipe(
          pswpElement,
          PhotoSwipeUI_Default,
          items,
          options
        );
        gallery.init();
      }
    );
  },
};

export default templateQuality;
